import { render } from "./WildBookFilter.vue?vue&type=template&id=5ff31175&scoped=true&ts=true"
import script from "./WildBookFilter.vue?vue&type=script&lang=ts"
export * from "./WildBookFilter.vue?vue&type=script&lang=ts"

import "./WildBookFilter.vue?vue&type=style&index=0&id=5ff31175&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff31175"]])

export default __exports__